module.exports = __webpack_public_path__ + "static/img/copy.c0c30236.svg";